import { useState } from "react";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import Modal from "react-bootstrap/Modal";
import Swal from "sweetalert2";
import { bookingStatus } from "../services/adminApiService/venueManagerApi/venueManagerApi";

function RemarkModal({ show, handleClose, id }) {
  const [remarks, setRemarks] = useState("");
  const [error, setError] = useState("");

  const handleApprove = async () => {
    if (remarks.trim() === "") {
      return setError("Please enter remarks before proceeding.");
    }
    try {
      let res = await bookingStatus(id, "Completed", remarks);
      if (res?.status === 200) {
        Swal.fire({
          icon: "success",
          title: "Success",
          text: res.data.message,
        });
      }
    } catch (error) {
      console.log(error);
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: error?.response?.data?.message || "Something went wrong!",
      });
    }
    handleClose();
  };

  const handleReject = async () => {
    try {
      let res = await bookingStatus(id, "Canceled", remarks);
      if (res?.status === 200) {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: res.data.message,
        });
      }
    } catch (error) {
      console.log(error);
      // alert(error?.response?.data?.message)
        Swal.fire({
        icon: "error",
        title: "Oops...",
        text: error?.response?.data?.message || "Something went wrong!",
      });
    }
    handleClose();
  };

  return (
    <Modal show={show} onHide={handleClose}>
      <Modal.Header closeButton>
        <Modal.Title className="w-100 text-center font-bold">
          Payment Received ?
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form>
          <Form.Group className="mb-3" controlId="exampleForm.ControlTextarea1">
            <Form.Label className="fs-4">Remarks</Form.Label>
            <Form.Control
              as="textarea"
              rows={6}
              value={remarks}
              onChange={(e) => {
                setRemarks(e.target.value);
                if (error) {
                  setError("");
                }
              }}
              required
            />
            {error && (
              <span
                style={{
                  color: "rgba(198, 40, 40, 1)",
                  padding: "10px 0px 10px 5px",
                }}
                className="text-danger"
              >
                {error}
              </span>
            )}
          </Form.Group>
        </Form>
      </Modal.Body>

      <Modal.Footer className="d-flex justify-content-center">
        <Button
          variant="danger"
          onClick={handleReject}
          style={{
            width: "15rem",
            backgroundColor: "#fff",
            color: "rgba(198, 40, 40, 1)",
          }}
        >
          Reject
        </Button>
        <Button
          variant="primary"
          onClick={handleApprove}
          style={{ backgroundColor: "#4aa564", width: "15rem" }}
        >
          Approve
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default RemarkModal;
